import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAcUI9Jp7DBbbqaH-ppdBzQ3cLNbe3sf7g',
  authDomain: 'drone-report-beta.firebaseapp.com',
  projectId: 'drone-report-beta',
  storageBucket: 'drone-report-beta.appspot.com',
  messagingSenderId: '25390847321',
  appId: '1:25390847321:web:8bebbdcfee6523072f2848',
  measurementId: 'G-SQJPEZ6CWD',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const storage = firebase.storage();
export const auth = firebase.auth();
export const Timestamp = firebase.firestore.Timestamp;
export type FirebaseQuery = firebase.firestore.Query<
  firebase.firestore.DocumentData
>;

export type CollectionReference = firebase.firestore.CollectionReference<
  firebase.firestore.DocumentData
>;
export default db;
